import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      tableHeader: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        { text: 'کاربر', value: 'user', align: 'center', isGroupable: true },
        {
          text: 'تاریخ ورود',
          value: 'startDate',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'تاریخ خروج',
          value: 'endDate',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'مدت زمان',
          value: 'duration',
          align: 'center',
          isGroupable: true,
        },
      ],
      tableItems: [],
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (const [index, item] of data.entries()) {
        let startdate = '-';
        if (item.loginDate) {
          startdate = Vue.moment(item.loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        let endDate = '-';
        if (item.logoutDate) {
          endDate = Vue.moment(item.logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        let duration = null;
        if (item.loginDate && item.logoutDate) {
          duration = Math.abs(item.logoutDate - item.loginDate);
        }
        let user = '-';
        user = `${item?.userAccount?.firstName} ${item?.userAccount?.lastName}`;
        this.tableItems.push({
          startDate: startdate,
          endDate: endDate,
          user: user ? user : '-',
          counter: index + 1,
          duration: duration ? this.msToTime(duration) : '-',
        });
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    backToReport: function () {
      this.$router.push({ name: 'phoneActivityReport' });
    },
  },
};
